import { render, staticRenderFns } from "./EditAccPlans.vue?vue&type=template&id=ad98db98&"
import script from "./EditAccPlans.vue?vue&type=script&lang=js&"
export * from "./EditAccPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports